var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8596 37.7969C14.6352 37.7969 16.0746 36.3628 16.0746 34.5938C16.0746 32.8247 14.6352 31.3906 12.8596 31.3906C11.0839 31.3906 9.64453 32.8247 9.64453 34.5938C9.64453 36.3628 11.0839 37.7969 12.8596 37.7969Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5783 37.7969C31.3539 37.7969 32.7933 36.3628 32.7933 34.5938C32.7933 32.8247 31.3539 31.3906 29.5783 31.3906C27.8027 31.3906 26.3633 32.8247 26.3633 34.5938C26.3633 36.3628 27.8027 37.7969 29.5783 37.7969Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79718 11.5312H35.6405L31.7643 25.0477C31.6108 25.5832 31.2863 26.0542 30.8401 26.3895C30.3939 26.7249 29.8502 26.9063 29.2913 26.9062H13.1464C12.5875 26.9063 12.0438 26.7249 11.5976 26.3895C11.1513 26.0542 10.8269 25.5832 10.6734 25.0477L5.22651 6.05426C5.14973 5.78655 4.98752 5.55103 4.76441 5.38337C4.5413 5.2157 4.26944 5.125 3.98998 5.125H1.92871",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/cartWhite.65f9126ac9270f1f3f284cec9213f449.svg";
export { ForwardRef as ReactComponent };